import { FlexBox } from 'common/utils/styles/flex-box';
import { MediaBreakpoints, spacing } from 'common/utils/helpers/theme.helpers';
import styled, { createGlobalStyle } from 'styled-components';
import { THEME_DEFAULTS } from 'common/utils/constants/theme.constants';

export const AppLayout = styled.div`
  display: flex;
  min-height: 100vh;
  flex-direction: column;
  background: ${({ theme }) => theme.customColors.F997};

  ${MediaBreakpoints.down('md')} {
    width: 100%;
    min-width: 100%;
    max-width: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    padding-left: env(safe-area-inset-left);
    padding-right: env(safe-area-inset-right);
  }

  ${MediaBreakpoints.between('md', 'xxl')} {
    width: ${THEME_DEFAULTS.BREAKPOINTS.xxl}px;
  }
  ${MediaBreakpoints.up('xxl')} {
    max-width: ${THEME_DEFAULTS.BREAKPOINTS.xxl}px;
    margin: 0 auto;
  }
`;

export const AppContent = styled.main`
  flex: 1;
  margin-right: ${spacing(11)};
  margin-left: ${spacing(11)};
  margin-top: ${spacing(15)};

  ${MediaBreakpoints.down('md')} {
    margin-right: 0;
    margin-left: 0;
    margin-top: ${spacing(10)};
    width: 100vw;
    min-width: 100vw;
    max-width: 100vw;
    box-sizing: border-box;
  }
`;

export const AuthContent = styled.main`
  flex: 1;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  max-width: 1024px;
  margin: 0 auto;

  padding-left: ${spacing(11)};
  padding-right: ${spacing(11)};

  ${MediaBreakpoints.down('md')} {
    align-items: stretch;
    margin-top: ${spacing(5)};
    padding-left: ${spacing(5)};
    padding-right: ${spacing(5)};
  }
`;

export const AuthInnerContainer = styled(FlexBox)`
  width: 100%;
`;

export const AuthClientLogo = styled.div`
  margin-bottom: ${spacing(19)};
`;

export const AuthImageContainer = styled.div`
  position: relative;

  & > div {
    position: absolute;
    right: 6%;
    top: -16%;
  }
  ${MediaBreakpoints.down('md')} {
    display: none;
  }
`;

/* These css overrides for Select Dropdown is not achievable using Styled Component */
export const GlobalStylesOverrides = createGlobalStyle`

  & .language-dropdown-option {
    width: 120px !important;
    background-color: ${({ theme }) => theme.palette.neutral.white} !important;
    &:hover {
      background-color: ${({ theme }) => theme.palette.neutral.white} !important;
    }
  }

  & .lang-selected {
    background-color: ${({ theme }) => theme.palette.light.N20} !important;
    &:hover {
      background-color: ${({ theme }) => theme.palette.light.N20} !important;
    }
  }

  // This is the only way available to customize dropdown

  & .rc-select-arrow svg {
    fill:   ${({ theme }) => theme.customColors.F998} !important;
  }

  & .account-dropdown {
    width: fit-content !important;
  }

  & .rc-select-item-option-disabled {
    opacity: 0.5;
  }

  & .account-dropdown-option {
    min-width: 140px !important;
    padding-right: 0 !important;
    padding-left: ${spacing(6)} !important;
    padding-top: ${spacing(2)} !important;
    padding-bottom: ${spacing(2)} !important;
  }

  & .MuiMenu-list {
    max-height: 90px !important;
    overflow-y: auto !important;

    ::-webkit-scrollbar {
      width: 12px !important;
    }
    ::-webkit-scrollbar-track {
      background: ${({ theme }) => theme.palette.neutral.white};
      border-radius: 6px;
    }
    ::-webkit-scrollbar-thumb {
      background: ${({ theme }) => theme.palette.product.F999};
      border-radius: 20px;
      border: 3px solid ${({ theme }) => theme.palette.neutral.white};
    }
  }

  ${MediaBreakpoints.down('md')} {
    & .MuiPopover-root#document-page-popover > div:nth-child(3) {
        box-shadow: 0px 2px 6px  rgba(69, 69, 69, 0.2) !important;
        border-radius: ${spacing(1.5)} !important;
        padding: ${spacing(2)} !important;
        width: max-content !important;
        transform: translate(-${spacing(5)}) !important;
    }
  }
  ${MediaBreakpoints.up('md')} {
    & .MuiPopover-root#document-page-popover {
        display: none;
    }
  }
`;
